<div
  class="flex min-h-screen flex-col items-center justify-center gap-10 bg-gray-100 py-10"
  *transloco="let t; read: 'subscriptionExpired'"
>
  <img src="assets/images/logo/taxtimer-logo.svg" alt="TaxTimer Logo" />

  <div class="relative z-10 w-[80vw] rounded-[5px] bg-white p-8">
    <div class="flex flex-col gap-6">
      <div class="text-center">
        <h3>{{ t('title') }}</h3>
        <p class="text-large-regular mt-2 text-gray-700">{{ t(reasonKey) }}</p>
      </div>

      @if (isLoading) {
        <div class="flex justify-center py-10">
          <app-loader color="blue"></app-loader>
        </div>
      } @else if (canUsePortal) {
        <div class="flex flex-col items-center gap-4">
          <p class="text-medium-regular text-center text-gray-700">{{ t('portal.description') }}</p>
          <button
            type="button"
            (click)="openCustomerPortal()"
            [disabled]="isOpeningPortal"
            class="bg-primary text-small-bold cursor-pointer rounded-[5px] px-6 py-3 text-white disabled:opacity-60"
          >
            {{ isOpeningPortal ? t('portal.opening') : t('portal.button') }}
          </button>
        </div>
      } @else if (hasError) {
        <p class="text-medium-regular text-center text-red-600">{{ t(errorKey) }}</p>
      } @else if (clientSecret) {
        <stripe-pricing-table
          [attr.pricing-table-id]="pricingTableId"
          [attr.publishable-key]="publishableKey"
          [attr.customer-session-client-secret]="clientSecret"
        ></stripe-pricing-table>
      }

      <div class="flex justify-center">
        <button type="button" (click)="logout()" class="!text-small-bold text-primary cursor-pointer">{{ t('buttons.logout') }}</button>
      </div>
    </div>
  </div>
  <app-legal-links-container></app-legal-links-container>
</div>
